import { AccountListItem } from "../../../types";
import { Stack, Typography } from "@mui/material";
import { isTextEllipsed } from "../../../utils/general_utils";
import { RateIndicatorIcon } from "../../ui/RateIndicatorIcon";
import { RoundedCircularProgress } from "../../ui";

export const EngagementScoreCell = ({ row }: { row: AccountListItem }) => {
  const { indicator, score, change, changed_at } = row.engagement;
  const totalEngagementScore = score || 0;
  return (
    <Stack
      alignItems="center"
      onMouseEnter={(event: React.MouseEvent<HTMLDivElement>) =>
        isTextEllipsed(event.currentTarget)
      }
    >
      <Stack alignItems="center">
        <Stack
          sx={{ position: "relative", width: "42px", height: "42px" }}
          justifyContent="center"
        >
          <Stack
            sx={{
              position: "absolute",
              left: -26,
              top: 10,
              zIndex: 2,
            }}
          >
            <RateIndicatorIcon
              indicatorRate={indicator}
              indicatorChangeAt={changed_at}
              indicatorChange={change}
            />
          </Stack>
          <RoundedCircularProgress
            size={42}
            thickness={4}
            variant="determinate"
            sx={{
              color: "#D4D4D4",
              position: "absolute",
              left: 0,
              top: 0,
              zIndex: 1,
              opacity: 1,
            }}
            value={100}
          />
          <RoundedCircularProgress
            size={42}
            thickness={4}
            variant="determinate"
            sx={{
              color: "#3980B9",
              position: "absolute",
              left: 0,
              top: 0,
              zIndex: 2,
              opacity: 1,
            }}
            value={totalEngagementScore}
          />
          <Typography
            variant="body1"
            align="center"
            sx={{
              flexShrink: 1,
              fontSize: 11,
              fontWeight: 600,
              color: "#232323",
            }}
          >
            {totalEngagementScore}%
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
